export default "__VITE_ASSET__e6f53390__"